import React, { useState } from 'react';
import { Layout, Menu, ConfigProvider } from 'antd';
import { TeamOutlined, BankOutlined, WarningOutlined, RocketOutlined, BookOutlined, RobotOutlined } from '@ant-design/icons';
import ptBR from 'antd/locale/pt_BR';
import SearchPageNew from './SearchPage_atual';
import SociosPage from './SociosPage';
import PGFNPage from './pages/PGFNPage';
import ProdutosDashboard from './pages/ProdutosDashboard';
import CNPJDetailPage from './pages/CNPJDetailPage';
import JuridicoPage from './pages/JuridicoPage';
import IAProspeccaoPage from './pages/IAProspeccaoPage';
import 'antd/dist/reset.css';
import './App.css';

const { Header, Content, Footer } = Layout;

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState('empresas');
  const [selectedCNPJ, setSelectedCNPJ] = useState<string | null>(null);

  const menuItems = [
    {
      key: 'empresas',
      icon: <BankOutlined />,
      label: 'Empresas',
    },
    {
      key: 'socios',
      icon: <TeamOutlined />,
      label: 'Sócios',
    },
    {
      key: 'produtos',
      icon: <RocketOutlined />,
      label: 'Produtos PGFN',
    },
    {
      key: 'pgfn',
      icon: <WarningOutlined />,
      label: 'PGFN Dívidas',
    },
    {
      key: 'juridico',
      icon: <BookOutlined />,
      label: 'Jurídico CARF',
    },
    {
      key: 'ia-prospeccao',
      icon: <RobotOutlined />,
      label: 'IA Prospecção',
    },
  ];

  const renderPage = () => {
    // Se há um CNPJ selecionado, mostrar página de detalhes
    if (selectedCNPJ) {
      return (
        <CNPJDetailPage 
          cnpj={selectedCNPJ} 
          onBack={() => setSelectedCNPJ(null)} 
        />
      );
    }
    
    switch (currentPage) {
      case 'socios':
        return <SociosPage onSelectCNPJ={(cnpj) => setSelectedCNPJ(cnpj)} />;
      case 'produtos':
        return <ProdutosDashboard onSelectCNPJ={(cnpj) => setSelectedCNPJ(cnpj)} />;
      case 'pgfn':
        return <PGFNPage />;
      case 'juridico':
        return <JuridicoPage />;
      case 'ia-prospeccao':
        return <IAProspeccaoPage />;
      case 'empresas':
      default:
        return <SearchPageNew onSelectCNPJ={(cnpj) => setSelectedCNPJ(cnpj)} />;
    }
  };

  return (
    <ConfigProvider locale={ptBR}>
      <Layout style={{ minHeight: '100vh' }}>
        <Header style={{ 
          display: 'flex', 
          alignItems: 'center',
          background: '#001529',
          padding: '0 24px'
        }}>
          <div style={{ 
            color: 'white', 
            fontSize: '22px', 
            fontWeight: 'bold',
            marginRight: '40px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            NewWay NW
          </div>
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[currentPage]}
            items={menuItems}
            onClick={({ key }) => {
              setSelectedCNPJ(null); // Limpar empresa selecionada ao trocar de aba
              setCurrentPage(key);
            }}
            style={{ flex: 1, minWidth: 0 }}
          />
        </Header>
        <Content style={{ padding: '24px', background: '#f0f2f5' }}>
          {renderPage()}
        </Content>
        <Footer style={{ textAlign: 'center', background: '#f0f2f5' }}>
          NewWay NW ©2026 - Business Intelligence para Advocacia Tributária
        </Footer>
      </Layout>
    </ConfigProvider>
  );
};

export default App;
